import QuickActionButton from "../../components/common/QuickActionButton";
import {
  IntlProvider,
  FormattedMessage,
  FormattedList,
  useIntl,
} from "react-intl";
const HeaderClients = ({}: any) => {
  return (
    <div className="flex justify-between w-full mb-6">
      <div className="w-full">
        <div className="text-color-primary text-2xl font-semibold leading-7">
          <FormattedMessage id="clientsTitle" />
        </div>
        <div className="my-4 text-color-gray text-base font-normal leading-7 ">
          <FormattedMessage id="clientsParagraph" />
        </div>
      </div>
      <div className="w-full flex justify-end">
        <QuickActionButton />
      </div>
    </div>
  );
};

export default HeaderClients;
